import * as React from "react"
import { ColorKeys } from "../../styles"
import {
	close,
	heart,
	heartFilled,
	plus,
	minus,
	arrowLeft,
	arrowRight,
	arrowUp,
	arrowDown,
	arrowUpRight,
	chevronDown,
	chevronUp,
	chevronMenuDown,
	menu,
	warningTriangle,
	infoCircle,
	check,
	checkSolid,
	user,
	filter,
	playCircle,
	moreVertical,
	accountSettings,
	logout,
	linkedIn,
	facebook2,
	instagram,
	chevronLeft,
	chevronRight,
	search,
	ellipse,
	geoPosition
} from "./UIIcons"
import {
	medicalConditionCough,
	medicalSpecialtyStomach,
	pill,
	tennisPlayer,
	multipleCircle,
	bandageShoulder,
	scienceBacteria,
	babyNewborn,
	familyChildHoldHand,
	medicalNotes,
	laboratoryTestBloodFinger,
	calendar,
	calendarCheck,
	houseChimney2,
	babyCarePacifier,
	medicalRibbonCancer,
	messagesBubbleTyping1,
	partyMusicDance,
	laboratoryTestBloodSugar,
	seatRegular,
	laptop,
	alarmBell,
	studyBook,
	weatherNightClear,
	graphStats,
	hospitalHouse,
	socialMediaFacebook1,
	multipleActionsStar,
	insuranceHand,
	policeFootstep,
	questionCircle,
	designDraw,
	gammal,
	medicalPersonnelHat,
	medicalSpecialtyEye,
	disabilitySitPregnancy,
	yogaStretch,
	fitnessDumbbellLift,
	singleWomanActionsView,
	medicalConditionSoreThroat,
	handExpand,
	pin,
	brainNetwork,
	monitorHeartBeat,
	disabilityWalkingAid,
	laboratorySample,
	soccerPlayerBall,
	informationCircle,
	transfusionWater,
	medicalFile,
	medicalSpecialtyKnee1,
	labTube,
	fruitApple,
	drugsPill,
	userSignal,
	medicalSpecialtyKnee,
	dietHealth,
	medicalSpecialtyBreathing,
	yogaMeditate,
	medicalSpecialtyNose,
	focusEye,
	viewCircle1,
	view1,
	irisScanSearch,
	hospitalFirstAid,
	medicalSpecialtyEar,
	hospitalBedroomNurse,
	fitnessWeightlift,
	phone,
	professionsManDoctor1,
	hospitalBoard,
	cashPaymentBill1,
	medicalRoomWait,
	singleNeutral,
	bloodDropSearch,
	singleNeutralSearch,
	brainHead1,
	conversationChatBubble,
	fitnessDumbbell,
	radiologyScanning,
	loveHat,
	bandage,
	smileySleepy,
	userWomanStress,
	singleNeutralActionsGraduate,
	irisScan2,
	pregnancyUltrasound,
	monitorUser,
	singleNeutralActionsView,
	presentationSpeaker,
	safetyElectricityDanger1,
	medicalInstrumentSyringe1,
	legalScaleUnequal1,
	mobilePhone,
	meetingTeamMonitor1,
	yogaShoulderStretch,
	medicalInstrumentStethoscope,
	pregnant1,
	medicalSpecialtyRehabilitation,
	radiologyScanDoctor,
	loveHeartHandsHold1,
	hospitalSign,
	roadSignWarning,
	bandageLegHanging,
	medicalSpecialtySkin,
	loveHeartArrow,
	kids1,
	uterus1,
	loveHeartHandsHold3,
	pain1,
	medicalSpecialtyLungs,
	surgery,
	professionsManNurse2,
	medicalAppSmartphone1,
	hemsjukvard,
	messagesPeopleUserQuestion,
	antiBacterial2,
	familyChild,
	medicalFilesMedicalCheck,
	temperatureThermometerMedium,
	petsTickFree,
	languageBarrierQuestion,
	recruitingEmployeeResumeDocumentReview,
	capioPartnerBusinessDealHandshake,
	brightness,
	bloodSample2,
	donationCharityHandShareHeart,
	chemicalHexagon1,
	hospitalBuilding,
	cross,
	petriDish4,
	microscope2,
	laboratoryDrugFile,
	petsTick,
	wave,
	insuranceHands,
	dentistryToothJaws,
	dentistryToothSearch,
	dentistryToothShield1,
	dentistryToothShield,
	dentistryTooth,
	tooth1,
	dentalImplant1,
	dentalXray,
} from "./CapioIcons"

export const defaultColor: ColorKeys = "bodyTextColor"

export interface IconPathProps {
	color?: ColorKeys
}

export type IconTypesUI =
	| "plus"
	| "minus"
	| "arrow-up"
	| "arrow-left"
	| "arrow-right"
	| "arrow-down"
	| "arrow-up-right"
	| "close"
	| "chevron-down"
	| "chevron-up"
	| "chevron-left"
	| "chevron-right"
	| "heart"
	| "heart-filled"
	| "menu"
	| "chevron-menu-down"
	| "warning-triangle"
	| "info-circle"
	| "check"
	| "check-solid"
	| "user"
	| "filter"
	| "playCircle"
	| "more-vertical"
	| "account-settings"
	| "logout"
	| "linkedIn"
	| "facebook2"
	| "instagram"
	| "search"
	| "ellipse"
	| "geo-position"

export type IconTypesCapio =
	| "medical-condition-cough"
	| "allergi-astma-kol"
	| "pill"
	| "apotek"
	| "tennis-player"
	| "armbage"
	| "medical-specialty-stomach"
	| "ätstörningar"
	| "mage-tarm"
	| "viktoperationer"
	| "multiple-circle"
	| "avdelning"
	| "bandage-shoulder"
	| "axel"
	| "science-bacteria"
	| "bakterie"
	| "baby-newborn"
	| "barn-amning"
	| "family-child-hold-hand"
	| "barnskador"
	| "medical-notes"
	| "bli-patient"
	| "laboratory-test-blood=finger"
	| "blodprov"
	| "calendar"
	| "boka_avboka"
	| "calendar-check"
	| "boka-tid"
	| "house-chimney-2"
	| "bostad"
	| "baby-care-pacifier"
	| "bvc"
	| "medical-ribbon-cancer"
	| "cancer"
	| "messages-bubble-typing-1"
	| "chatta"
	| "party-music-dance"
	| "dans"
	| "laboratory-test-blood-sugar"
	| "diabetes"
	| "seat-regular"
	| "dialys"
	| "laptop"
	| "digitalt-vårdbesåk"
	| "alarm-bell"
	| "drop-in"
	| "study-book"
	| "dyslexi"
	| "weather-night-clear"
	| "efter-stängning"
	| "graph-stats"
	| "ekg"
	| "hospital-house"
	| "enhet"
	| "social-media-facebook-1"
	| "facebook"
	| "multiple-actions-star"
	| "företagshälsovård"
	| "insurance-hand"
	| "försäkringsbolag"
	| "police-footstep"
	| "fot"
	| "question-circle"
	| "frågetecken"
	| "design-draw"
	| "friskintyg"
	| "gammal"
	| "medical-personnel-hat"
	| "generell"
	| "kirurgi"
	| "medical-specialty-eye"
	| "gråstarroperationer"
	| "disability-sit-pregnancy"
	| "graviditet"
	| "yoga-stretch"
	| "grupprehabilitering"
	| "fitness-dumbbell-lift"
	| "gym-rehab"
	| "single-woman-actions-view"
	| "gynekologi"
	| "medical-condition-sore-throat"
	| "hals"
	| "hand-expand"
	| "hand"
	| "pin"
	| "brain-network"
	| "hjärna-nerver"
	| "monitor-heart-beat"
	| "hjärta-blod-lymf"
	| "disability-walking-aid"
	| "höft"
	| "laboratory-sample"
	| "hormonella-sjukdomar"
	| "soccer-player-ball"
	| "idrottsrelaterade-besvär-eller-skador"
	| "information-circle"
	| "information"
	| "transfusion-water"
	| "infusion"
	| "medical-file"
	| "intyg"
	| "undersökning"
	| "medical-specialty-knee-1"
	| "knä"
	| "lab-tube"
	| "könssjukdom"
	| "fruit-apple"
	| "kostrådgivning"
	| "drugs-pill"
	| "läkemedelsbehandling"
	| "user-signal"
	| "långvarig-smärta"
	| "medical-specialty-knee"
	| "leder-muskler-skelett"
	| "diet-health"
	| "levnadsvanor"
	| "medical-specialty-breathing"
	| "luft-önh"
	| "yoga-meditate"
	| "mindfulness"
	| "medical-specialty-nose"
	| "näsa"
	| "focus-eye"
	| "ögonbottenfotografering"
	| "view-circle-1"
	| "ögonproblem-och-ögonsjukdomar-ögonmottagning"
	| "view-1"
	| "ögon-syn"
	| "iris-scan-search"
	| "ögonundersökning"
	| "hospital-first-aid"
	| "operationer-behandlingar"
	| "medical-specialty-ear"
	| "öra"
	| "hospital-bedroom-nurse"
	| "övrig-kirurgi"
	| "fitness-weightlift"
	| "personlig-träning"
	| "phone"
	| "professions-man-doctor-1"
	| "plastikkirurgi"
	| "hospital-board"
	| "primärvård"
	| "cash-payment-bill-1"
	| "priser"
	| "medical-room-wait"
	| "privat-vård"
	| "single-neutral"
	| "profil"
	| "blood-drop-search"
	| "provtagning"
	| "provtagningar"
	| "single-neutral-search"
	| "brain-head-1"
	| "psykisk-ohälsa"
	| "conversation-chat-bubble"
	| "psykologisk-behnadling"
	| "fitness-dumbbell"
	| "rehab"
	| "radiology-scanning"
	| "röntgen"
	| "love-hat"
	| "sex-samliv"
	| "bandage"
	| "skador-olyckor"
	| "smiley-sleepy"
	| "sömn"
	| "user-woman-stress"
	| "stress"
	| "single-neutral-actions-graduate"
	| "student"
	| "psykiatriska-utredningar"
	| "iris-scan-2"
	| "synfels-och-ögonlaserbehandlingar"
	| "pregnancy-ultrasound"
	| "ultraljudsundersökningar"
	| "monitor-user"
	| "undersökningar-skopier"
	| "single-neutral-actions-view"
	| "urologi"
	| "presentation-speaker"
	| "utbildning"
	| "safety-electricity-danger-1"
	| "utmattning"
	| "medical-instrument-syringe-1"
	| "vaccination"
	| "legal-scale-unequal-1"
	| "våg"
	| "mobile-phone"
	| "vårdbesök-mobil"
	| "meeting-team-monitor-1"
	| "videomöte"
	| "yoga-shoulder-stretch"
	| "reumatologi"
	| "medical-instrument-stethoscope"
	| "health-care"
	| "pregnant-1"
	| "medical-specialty-rehabilitation"
	| "radiology-scan-doctor"
	| "love-heart-hands-hold-1"
	| "hospital-sign"
	| "road-sign-warning"
	| "bandage-leg-hanging"
	| "medical-specialty-skin"
	| "hud"
	| "love-heart-arrow"
	| "kids-1"
	| "uterus-1"
	| "love-heart-hands-hold-3"
	| "pain-1"
	| "ring-oss"
	| "hitta_hit"
	| "medical-specialty-lungs"
	| "spirometriundersökning"
	| "infektion"
	| "vårdcentral"
	| "surgery"
	| "health-center"
	| "child-care-centers"
	| "oron-nasa-hals"
	| "eye"
	| "cellprovstagning"
	| "professions-man-nurse-2"
	| "vardbesok-mobil"
	| "medical-app-smartphone-1"
	| "hemsjukvard"
	| "messages-people-user-question"
	| "anti-bacterial-2"
	| "family-child"
	| "medical-files-medical-check"
	| "temperature-thermometer-medium"
	| "pets-tick-free"
	| "language-barrier-question"
	| "recruiting-employee-resume-document-review"
	| "capio_partner_business-deal-handshake"
	| "brightness"
	| "blood-sample-2"
	| "donation-charity-hand-share-heart"
	| "chemical-hexagon-1"
	| "hospital-building"
	| "cross"
	| "petri-dish-4"
	| "microscope-2"
	| "laboratory-drug-file"
	| "pets-tick"
	| "wave"
	| "insurance-hands"
	| "dentistry-tooth-jaws"
	| "dentistry-tooth-search"
	| "dentistry-tooth-shield-1"
	| "dentistry-tooth-shield"
	| "dentistry-tooth"
	| "tooth-1"
	| "dental-implant-1"
	| "dental-xray"

export type IconTypes = IconTypesUI | IconTypesCapio

type IconMap = Record<IconTypes, React.FC<IconPathProps>>

export const iconMap: IconMap = {
	"more-vertical": moreVertical,
	plus,
	minus,
	close,
	"arrow-left": arrowLeft,
	"arrow-right": arrowRight,
	"arrow-up": arrowUp,
	"arrow-down": arrowDown,
	"arrow-up-right": arrowUpRight,
	"chevron-down": chevronDown,
	"chevron-up": chevronUp,
	"chevron-left": chevronLeft,
	"chevron-right": chevronRight,
	"chevron-menu-down": chevronMenuDown,
	heart: heart,
	"heart-filled": heartFilled,
	menu,
	"warning-triangle": warningTriangle,
	"info-circle": infoCircle,
	check,
	"check-solid": checkSolid,
	user,
	filter,
	calendar,
	"account-settings": accountSettings,
	logout,
	linkedIn,
	facebook2,
	instagram,
	"geo-position": geoPosition,
	"medical-condition-cough": medicalConditionCough,
	"allergi-astma-kol": medicalConditionCough,
	pill,
	apotek: pill,
	"tennis-player": tennisPlayer,
	armbage: tennisPlayer,
	"medical-specialty-stomach": medicalSpecialtyStomach,
	ätstörningar: medicalSpecialtyStomach,
	"mage-tarm": medicalSpecialtyStomach,
	viktoperationer: medicalSpecialtyStomach,
	surgery: surgery,
	"multiple-circle": multipleCircle,
	avdelning: multipleCircle,
	"bandage-shoulder": bandageShoulder,
	axel: bandageShoulder,
	"science-bacteria": scienceBacteria,
	infektion: scienceBacteria,
	bakterie: scienceBacteria,
	"baby-newborn": babyNewborn,
	"barn-amning": babyNewborn,
	"child-care-centers": babyNewborn,
	"family-child-hold-hand": familyChildHoldHand,
	barnskador: familyChildHoldHand,
	"medical-notes": medicalNotes,
	"bli-patient": medicalNotes,
	"laboratory-test-blood=finger": laboratoryTestBloodFinger,
	blodprov: laboratoryTestBloodFinger,
	boka_avboka: calendar,
	"calendar-check": calendarCheck,
	"boka-tid": calendarCheck,
	"house-chimney-2": houseChimney2,
	bostad: houseChimney2,
	"baby-care-pacifier": babyCarePacifier,
	bvc: babyCarePacifier,
	"medical-ribbon-cancer": medicalRibbonCancer,
	cancer: medicalRibbonCancer,
	"messages-bubble-typing-1": messagesBubbleTyping1,
	chatta: messagesBubbleTyping1,
	"party-music-dance": partyMusicDance,
	dans: partyMusicDance,
	"laboratory-test-blood-sugar": laboratoryTestBloodSugar,
	diabetes: laboratoryTestBloodSugar,
	"seat-regular": seatRegular,
	dialys: seatRegular,
	laptop,
	"digitalt-vårdbesåk": laptop,
	"alarm-bell": alarmBell,
	"drop-in": alarmBell,
	"study-book": studyBook,
	dyslexi: studyBook,
	"weather-night-clear": weatherNightClear,
	"efter-stängning": weatherNightClear,
	"graph-stats": graphStats,
	ekg: graphStats,
	"hospital-house": hospitalHouse,
	enhet: hospitalHouse,
	"social-media-facebook-1": socialMediaFacebook1,
	facebook: socialMediaFacebook1,
	"multiple-actions-star": multipleActionsStar,
	företagshälsovård: multipleActionsStar,
	"insurance-hand": insuranceHand,
	försäkringsbolag: insuranceHand,
	"police-footstep": policeFootstep,
	fot: policeFootstep,
	"question-circle": questionCircle,
	frågetecken: questionCircle,
	"design-draw": designDraw,
	friskintyg: designDraw,
	gammal,
	"medical-personnel-hat": medicalPersonnelHat,
	generell: medicalPersonnelHat,
	kirurgi: medicalPersonnelHat,
	"medical-specialty-eye": medicalSpecialtyEye,
	gråstarroperationer: medicalSpecialtyEye,
	"disability-sit-pregnancy": disabilitySitPregnancy,
	graviditet: disabilitySitPregnancy,
	"yoga-stretch": yogaStretch,
	grupprehabilitering: yogaStretch,
	"fitness-dumbbell-lift": fitnessDumbbellLift,
	"gym-rehab": fitnessDumbbellLift,
	"single-woman-actions-view": singleWomanActionsView,
	gynekologi: singleWomanActionsView,
	"medical-condition-sore-throat": medicalConditionSoreThroat,
	hals: medicalConditionSoreThroat,
	"hand-expand": handExpand,
	hand: handExpand,
	pin,
	hitta_hit: pin,
	"brain-network": brainNetwork,
	"hjärna-nerver": brainNetwork,
	"monitor-heart-beat": monitorHeartBeat,
	"hjärta-blod-lymf": monitorHeartBeat,
	"disability-walking-aid": disabilityWalkingAid,
	höft: disabilityWalkingAid,
	"laboratory-sample": laboratorySample,
	"hormonella-sjukdomar": laboratorySample,
	"soccer-player-ball": soccerPlayerBall,
	"idrottsrelaterade-besvär-eller-skador": soccerPlayerBall,
	"information-circle": informationCircle,
	information: informationCircle,
	"transfusion-water": transfusionWater,
	infusion: transfusionWater,
	"medical-file": medicalFile,
	intyg: medicalFile,
	undersökning: medicalFile,
	"medical-specialty-knee-1": medicalSpecialtyKnee1,
	knä: medicalSpecialtyKnee1,
	"lab-tube": labTube,
	könssjukdom: labTube,
	"fruit-apple": fruitApple,
	kostrådgivning: fruitApple,
	"drugs-pill": drugsPill,
	läkemedelsbehandling: drugsPill,
	"user-signal": userSignal,
	"långvarig-smärta": userSignal,
	"medical-specialty-knee": medicalSpecialtyKnee,
	"leder-muskler-skelett": medicalSpecialtyKnee,
	"diet-health": dietHealth,
	levnadsvanor: dietHealth,
	"medical-specialty-breathing": medicalSpecialtyBreathing,
	"luft-önh": medicalSpecialtyBreathing,
	"oron-nasa-hals": medicalSpecialtyBreathing,
	"yoga-meditate": yogaMeditate,
	mindfulness: yogaMeditate,
	"medical-specialty-nose": medicalSpecialtyNose,
	näsa: medicalSpecialtyNose,
	"focus-eye": focusEye,
	ögonbottenfotografering: focusEye,
	eye: view1,
	"view-circle-1": viewCircle1,
	"ögonproblem-och-ögonsjukdomar-ögonmottagning": viewCircle1,
	"view-1": view1,
	"ögon-syn": view1,
	"iris-scan-search": irisScanSearch,
	ögonundersökning: irisScanSearch,
	"hospital-first-aid": hospitalFirstAid,
	"operationer-behandlingar": hospitalFirstAid,
	"medical-specialty-ear": medicalSpecialtyEar,
	öra: medicalSpecialtyEar,
	"hospital-bedroom-nurse": hospitalBedroomNurse,
	"övrig-kirurgi": hospitalBedroomNurse,
	"fitness-weightlift": fitnessWeightlift,
	"personlig-träning": fitnessWeightlift,
	phone,
	"ring-oss": phone,
	"professions-man-doctor-1": professionsManDoctor1,
	plastikkirurgi: professionsManDoctor1,
	"hospital-board": hospitalBoard,
	primärvård: hospitalBoard,
	vårdcentral: hospitalBoard,
	"cash-payment-bill-1": cashPaymentBill1,
	priser: cashPaymentBill1,
	"medical-room-wait": medicalRoomWait,
	"privat-vård": medicalRoomWait,
	"single-neutral": singleNeutral,
	profil: singleNeutral,
	"blood-drop-search": bloodDropSearch,
	provtagning: bloodDropSearch,
	provtagningar: bloodDropSearch,
	"single-neutral-search": singleNeutralSearch,
	"psykiatriska-utredningar": singleNeutralSearch,
	"brain-head-1": brainHead1,
	"psykisk-ohälsa": brainHead1,
	"conversation-chat-bubble": conversationChatBubble,
	"psykologisk-behnadling": conversationChatBubble,
	"fitness-dumbbell": fitnessDumbbell,
	rehab: fitnessDumbbell,
	"radiology-scanning": radiologyScanning,
	röntgen: radiologyScanning,
	"love-hat": loveHat,
	"sex-samliv": loveHat,
	bandage,
	"skador-olyckor": bandage,
	"smiley-sleepy": smileySleepy,
	sömn: smileySleepy,
	"user-woman-stress": userWomanStress,
	stress: userWomanStress,
	"single-neutral-actions-graduate": singleNeutralActionsGraduate,
	student: singleNeutralActionsGraduate,
	"iris-scan-2": irisScan2,
	"synfels-och-ögonlaserbehandlingar": irisScan2,
	"pregnancy-ultrasound": pregnancyUltrasound,
	utbildning: presentationSpeaker,
	ultraljudsundersökningar: pregnancyUltrasound,
	"monitor-user": monitorUser,
	"undersökningar-skopier": monitorUser,
	"single-neutral-actions-view": singleNeutralActionsView,
	urologi: singleNeutralActionsView,
	"presentation-speaker": presentationSpeaker,
	"safety-electricity-danger-1": safetyElectricityDanger1,
	utmattning: safetyElectricityDanger1,
	"medical-instrument-syringe-1": medicalInstrumentSyringe1,
	vaccination: medicalInstrumentSyringe1,
	"legal-scale-unequal-1": legalScaleUnequal1,
	våg: legalScaleUnequal1,
	"mobile-phone": mobilePhone,
	"vårdbesök-mobil": mobilePhone,
	"meeting-team-monitor-1": meetingTeamMonitor1,
	videomöte: meetingTeamMonitor1,
	"yoga-shoulder-stretch": yogaShoulderStretch,
	reumatologi: yogaShoulderStretch,
	"medical-instrument-stethoscope": medicalInstrumentStethoscope,
	"health-care": medicalInstrumentStethoscope,
	"pregnant-1": pregnant1,
	"medical-specialty-rehabilitation": medicalSpecialtyRehabilitation,
	"radiology-scan-doctor": radiologyScanDoctor,
	"love-heart-hands-hold-1": loveHeartHandsHold1,
	"hospital-sign": hospitalSign,
	"road-sign-warning": roadSignWarning,
	"bandage-leg-hanging": bandageLegHanging,
	"medical-specialty-skin": medicalSpecialtySkin,
	hud: medicalSpecialtySkin,
	"love-heart-arrow": loveHeartArrow,
	"kids-1": kids1,
	"uterus-1": uterus1,
	"love-heart-hands-hold-3": loveHeartHandsHold3,
	"pain-1": pain1,
	"medical-specialty-lungs": medicalSpecialtyLungs,
	spirometriundersökning: medicalSpecialtyLungs,
	"health-center": plus,
	playCircle,
	cellprovstagning: scienceBacteria,
	"professions-man-nurse-2": professionsManNurse2,
	"vardbesok-mobil": mobilePhone,
	"medical-app-smartphone-1": medicalAppSmartphone1,
	hemsjukvard,
	"messages-people-user-question": messagesPeopleUserQuestion,
	"anti-bacterial-2": antiBacterial2,
	"family-child": familyChild,
	"medical-files-medical-check": medicalFilesMedicalCheck,
	"temperature-thermometer-medium": temperatureThermometerMedium,
	"pets-tick-free": petsTickFree,
	"language-barrier-question": languageBarrierQuestion,
	"recruiting-employee-resume-document-review":
		recruitingEmployeeResumeDocumentReview,
	"capio_partner_business-deal-handshake": capioPartnerBusinessDealHandshake,
	brightness,
	"blood-sample-2": bloodSample2,
	"donation-charity-hand-share-heart": donationCharityHandShareHeart,
	"chemical-hexagon-1": chemicalHexagon1,
	"hospital-building": hospitalBuilding,
	cross,
	"petri-dish-4": petriDish4,
	"microscope-2": microscope2,
	"laboratory-drug-file": laboratoryDrugFile,
	"pets-tick": petsTick,
	wave,
	"insurance-hands": insuranceHands,
	search,
	ellipse,
	"dentistry-tooth-jaws": dentistryToothJaws,
	"dentistry-tooth-search": dentistryToothSearch,
	"dentistry-tooth-shield-1": dentistryToothShield1,
	"dentistry-tooth-shield": dentistryToothShield,
	"dentistry-tooth": dentistryTooth,
	"tooth-1": tooth1,
	"dental-implant-1": dentalImplant1,
	"dental-xray": dentalXray,
}
